module.exports = __webpack_public_path__ + "img/b_immun_left.88b68b24.jpeg";